import {
	Group,
	Button,
	Modal,
	TextInput,
	Checkbox,
	Text,
	Loader,
	Image,
	Input,
} from "@mantine/core";
import { useState, useEffect, useRef } from "react";
import { useForm } from "@mantine/form";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../utils/Notifications";
import { CDN_URL } from "../constant";
import { useSelector } from "react-redux";
import uploadIcon from "../static/svg/upload.svg";
import createExperience, { updateExperience } from "../API/createExperience";
function CreateNewModal({ isEdit, data, spaceID, refresh, setOpened, opened }) {
	const [uploadedFile, setUploadedFile] = useState(null);
	const [editExperinceFile, setEditExperinceFile] = useState(null);
	const UserId = useSelector(
		(state) => state.userInformationReducer.users.UserId
	);
	const [loading, setLoading] = useState(false);
	const fileInput = useRef(null);
	const [btn1ChkBx, setbtn1ChkBx] = useState(false);
	const [btn2ChkBx, setbtn2ChkBx] = useState(false);
	const [btn3ChkBx, setbtn3ChkBx] = useState(false);
	const handleFileUpload = (event) => {
		setUploadedFile(event.target.files[0]);
	};
	let experinceObject;
	if (isEdit) {
		const experinceData = JSON.parse(data?.Experiences);
		experinceObject = {
			btn1Text: experinceData?.links.button1.text,
			btn2Text: experinceData?.links.button2.text,
			btn3Text: experinceData?.links.button3.text,
			btn1ChkBx: experinceData?.links.button1.isActive,
			btn2ChkBx: experinceData?.links.button2.isActive,
			btn3ChkBx: experinceData?.links.button3.isActive,
			btn1Link: experinceData?.links.button1.link,
			btn2Link: experinceData?.links.button2.link,
			btn3Link: experinceData?.links.button3.link,
			panorama: experinceData?.panoramas,
			ThumbnailUrl: data?.ThumbnailUrl,
		};
	} else {
	}
	const form = useForm({
		initialValues: {
			btn1ChkBx: experinceObject ? experinceObject.btn1ChkBx : false,
			btn2ChkBx: experinceObject ? experinceObject.btn2ChkBx : false,
			btn3ChkBx: experinceObject ? experinceObject.btn3ChkBx : false,
			Name: data?.Name ? data?.Name : "",
			btn1Text: experinceObject ? experinceObject.btn1Text : "",
			btn1Link: experinceObject ? experinceObject.btn1Link : "",
			btn2Text: experinceObject ? experinceObject.btn2Text : "",
			btn2Link: experinceObject ? experinceObject.btn2Link : "",
			btn3Text: experinceObject ? experinceObject.btn3Text : "",
			btn3Link: experinceObject ? experinceObject.btn3Link : "",
		},
		validate: {
			Name: (value) =>
				value === "" ? "Please Enter Experince Name" : null,
		},
	});

	const handleSubmit = async (value) => {
		if (uploadedFile === null && editExperinceFile === null) {
			setLoading(false);
			showErrorNotification("Please Upload Image");
		} else {
			let formData = new FormData();
			formData.append("myfile", uploadedFile);
			formData.append(
				"bodyData",
				JSON.stringify({
					UserId: UserId,
					Name: value.Name,
					title: value.Name,
					links: {
						button1: {
							isActive: btn1ChkBx,
							text: value.btn1Text,
							link: value.btn1Link,
							color: "rgb(179, 207, 92)",
						},
						button2: {
							isActive: btn2ChkBx,
							text: value.btn2Text,
							link: value.btn2Link,
							color: "rgb(60, 59, 59)",
						},
						button3: {
							isActive: btn3ChkBx,
							text: value.btn3Text,
							link: value.btn3Link,
							color: "rgb(27, 62, 118)",
						},
					},
					panoramas: !isEdit ? [] : experinceObject.panorama,
				})
			);
			let result;
			!isEdit
				? (result = await createExperience(formData))
				: (result = await updateExperience(formData, spaceID));
			setLoading(false);
			refresh && refresh();
			form.reset();
			setbtn1ChkBx(false);
			setbtn2ChkBx(false);
			setbtn3ChkBx(false);
			showSuccessNotification("Experience added successfuly");
			setOpened(false);
		}
	};
	useEffect(() => {
		experinceObject?.btn1ChkBx ? setbtn1ChkBx(true) : setbtn1ChkBx(false);
		experinceObject?.btn2ChkBx ? setbtn2ChkBx(true) : setbtn2ChkBx(false);
		experinceObject?.btn3ChkBx ? setbtn3ChkBx(true) : setbtn3ChkBx(false);
		if (data?.ThumbnailUrl) {
			setEditExperinceFile(data?.ThumbnailUrl);
		}
	}, [
		experinceObject?.btn1ChkBx,
		experinceObject?.btn2ChkBx,
		experinceObject?.btn3ChkBx,
	]);
	return (
		<>
			<Modal
				size="lg"
				centered
				opened={opened}
				onClose={() => setOpened(false)}
				title="Create New Experience"
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
				style={{ zIndex: "100" }}
			>
				{loading && (
					<div className="LoadingModal">
						<Loader className="LoadingModal_loader" />
					</div>
				)}
				<form
					onSubmit={form.onSubmit((value) => {
						setLoading(true);
						handleSubmit(value);
					})}
				>
					<TextInput
						mb={10}
						label="Name"
						{...form.getInputProps("Name")}
						placeholder="Enter Experience Name"
						style={{ width: "96%" }}
						styles={{
							input: {
								backgroundColor: "#040F1F",
								border: "1px solid #09254E",
							},
							label: {
								color: "#ffffff",
								fontWeight: "700",
							},
						}}
					/>
					<Group
						style={{
							position: "relative",
						}}
					>
						{uploadedFile === null && editExperinceFile === null ? (
							<>
								<label
									htmlFor="file-input"
									style={{
										display: "flex",
										width: "96%",
										height: "50px",
										minHeight: "85px",
										alignItems: "center",
										justifyContent: "center",
										flexDirection: "column",
										border: "1px solid #09254E",
										borderRadius: "5px",
										cursor: "pointer",
									}}
								>
									<Image src={uploadIcon} width={30} />
									<Button
										variant="outline"
										my={5}
										px={5}
										size="xs"
										radius={"md"}
										style={{ fontSize: "11px" }}
										sx={(theme) => ({
											color: theme.colors.white[0],
											borderColor:
												theme.colors.ivisit_light[0],
										})}
										onClick={() => {
											fileInput.current.click();
										}}
									>
										Upload Thumbnail
									</Button>
								</label>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".jpg, .jpeg, .png"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : uploadedFile === null && editExperinceFile ? (
							<>
								<Image
									height={85}
									src={CDN_URL + editExperinceFile}
									fit="contain"
								/>
								<Button
									variant="filled"
									p={0}
									pt={0}
									size="xs"
									radius={"md"}
									style={{
										padding: "0px",
										fontSize: "8px",
										position: "absolute",
										top: "50%",
										left: "50%",
										transform: "translate(-50%, -50%)",
									}}
									sx={(theme) => ({
										color: theme.colors.white[0],
									})}
									onClick={() => {
										fileInput.current.click();
									}}
								>
									Change
								</Button>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".jpg, .jpeg, .png"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						) : (
							<>
								<Image
									height={85}
									src={URL.createObjectURL(uploadedFile)}
									fit="contain"
								/>
								<Button
									variant="filled"
									p={0}
									pt={0}
									size="xs"
									radius={"md"}
									style={{
										padding: "0px",
										fontSize: "8px",
										position: "absolute",
										top: "50%",
										left: "50%",
										transform: "translate(-50%, -50%)",
									}}
									sx={(theme) => ({
										color: theme.colors.white[0],
									})}
									onClick={() => {
										fileInput.current.click();
									}}
								>
									Change
								</Button>
								<Input
									id="file-input"
									ref={fileInput}
									type="file"
									accept=".jpg, .jpeg, .png"
									variant="unstyled"
									styles={{
										wrapper: {
											display: "none",
										},
									}}
									onChange={handleFileUpload}
								/>
							</>
						)}
					</Group>
					<Text style={{ fontWeight: "600", color: "white" }} mt={15}>
						Button Settings
					</Text>

					<Group
						mt={15}
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "self-end",
						}}
					>
						<Checkbox
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
							}}
							size="xs"
							onClick={() =>
								setbtn1ChkBx((state) => (state = !state))
							}
							{...form.getInputProps("btn1ChkBx", {
								type: "checkbox",
							})}
							style={{ position: "relative", bottom: "8px" }}
							m={0}
						/>
						<TextInput
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn1Text")}
							disabled={!btn1ChkBx}
							m={0}
							style={{ width: "30%" }}
							label="Text"
						/>
						<TextInput
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn1Link")}
							disabled={!btn1ChkBx}
							style={{ width: "58.5%" }}
							label="Link"
							m={0}
						/>
					</Group>
					<Group
						mt={15}
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "self-end",
						}}
					>
						<Checkbox
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
							}}
							size="xs"
							onClick={(event) =>
								setbtn2ChkBx((state) => (state = !state))
							}
							{...form.getInputProps("btn2ChkBx", {
								type: "checkbox",
							})}
							style={{ position: "relative", bottom: "8px" }}
							m={0}
						/>
						<TextInput
							m={0}
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn2Text")}
							disabled={!btn2ChkBx}
							style={{ width: "30%" }}
							label="Text"
						/>
						<TextInput
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn2Link")}
							disabled={!btn2ChkBx}
							style={{ width: "58.5%" }}
							label="Link"
							m={0}
						/>
					</Group>
					<Group
						mt={15}
						mb={10}
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "self-end",
						}}
					>
						<Checkbox
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
							}}
							size="xs"
							onClick={() =>
								setbtn3ChkBx((state) => (state = !state))
							}
							{...form.getInputProps("btn3ChkBx", {
								type: "checkbox",
							})}
							style={{ position: "relative", bottom: "8px" }}
							m={0}
						/>
						<TextInput
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn3Text")}
							disabled={!btn3ChkBx}
							m={0}
							style={{ width: "30%" }}
							label="Text"
						/>
						<TextInput
							styles={{
								input: {
									backgroundColor: "#040F1F",
									border: "1px solid #09254E",
								},
								label: {
									color: "#ffffff",
								},
							}}
							{...form.getInputProps("btn3Link")}
							disabled={!btn3ChkBx}
							style={{ width: "58.5%" }}
							label="Link"
							m={0}
						/>
					</Group>
					<Group
						mt={20}
						style={{
							width: "96%",
							display: "flex",
							justifyContent: "end",
						}}
					>
						<Button
							variant="outline"
							my={0}
							px={25}
							size="xs"
							radius={"md"}
							sx={(theme) => ({
								color: theme.colors.white[0],
								borderColor: theme.colors.ivisit_light[0],
							})}
							onClick={() => setOpened(false)}
						>
							Cancel
						</Button>
						<Button
							type="submit"
							variant="outline"
							my={0}
							px={25}
							size="xs"
							radius={"md"}
							sx={(theme) => ({
								color: theme.colors.white[0],
								borderColor: theme.colors.ivisit_light[0],
							})}
						>
							{isEdit ? "Update" : "Create"}
						</Button>
					</Group>
				</form>
			</Modal>
		</>
	);
}

export default CreateNewModal;
